import { getLowerCaseMessageByKey, getPascalCaseMessageByKey } from 'Stores/LanguageStore';

// Configurable credit terminology — the store credit / credit voucher issued for refunds.
// Ferry bookings use the "Ferry credit" term; non-ferry bookings (events, parking) use the
// generic "Credit" term. Both are editable via the Languages admin (keys below).
export const FERRY_CREDIT_MESSAGE_KEY = 'general__ferry-credit__label';
export const CREDIT_MESSAGE_KEY = 'general__credit__label';

const FERRY_CREDIT_DEFAULT = 'Ferry credit';
const CREDIT_DEFAULT = 'Credit';

const termKey = (isFerry: boolean) => (isFerry ? FERRY_CREDIT_MESSAGE_KEY : CREDIT_MESSAGE_KEY);
const termDefault = (isFerry: boolean) => (isFerry ? FERRY_CREDIT_DEFAULT : CREDIT_DEFAULT);

// Title-cased term, e.g. "Ferry credit" / "Credit" — for headings and standalone labels.
export const creditTermLabel = (isFerry: boolean): string =>
	getPascalCaseMessageByKey(termKey(isFerry), termDefault(isFerry));

// Lower-cased term, e.g. "ferry credit" / "credit" — for use mid-sentence.
export const creditTermInline = (isFerry: boolean): string =>
	getLowerCaseMessageByKey(termKey(isFerry), termDefault(isFerry)) ?? termDefault(isFerry).toLowerCase();
